import { useState } from 'react';
import { omit } from 'radash';
import { Button } from '../input';
import { Modal, closeHook } from '../modal';
import { styles } from '../../constants';
import { useGlobal } from '../../state';
import { TableFromObject } from '../table';
import { Run, RunJson, RunAgain, Code } from '../run';

export const ArgsTable = ({ job, ...props }) => {
  const args = job.params || {};
  delete args.signalId;
  return <TableFromObject obj={args} {...props} />;
};

export const Args = ({ job, onRunAgain }) => {
  const close = closeHook();

  const handleRun = () => {
    if (onRunAgain) {
      onRunAgain();
    }
    close.trigger();
  };

  return (
    <div style={{ ...styles.uiBox, display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ maxWidth: 800 }}>
        <ArgsTable job={job} />
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        {/*
        <Modal title={`Run ${job.method}`} close={close.signal}>
          <Button style={{ width: 160, marginTop: 5 }}>Run Again</Button>
          <Run endpoint={job.method} params={job.params} onRun={handleRun} />
            </Modal>
            */}

        <Modal title={`Code snippet for ${job.method}`}>
          <Button
            style={{ width: 160, marginTop: 5 }}
            flat
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            Get Code
          </Button>
          <div>
            <Code endpoint={job.method} params={omit(job.params, ['nonce'])} />
          </div>
        </Modal>
      </div>

      {/*
      <pre>{JSON.stringify(job, null, 2)}</pre>
      */}
    </div>
  );
};
